import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../helpers/axiosInstance";

export interface DeptStats {
  dept: string;
  totalEvents: number;
  totalVolunteers: number;
  totalHours: number;
  attendedCount: number;
  registeredCount: number;
  percentage: number;
}

export interface DeptOverallStats {
  totalEvents: number;
  totalVolunteers: number;
  totalHours: number;
  attendedCount: number;
  registeredCount: number;
  attendancePercentage: number;
}

export interface YearlyDeptData extends DeptOverallStats {
  year: number;
  totalDepartments: number;
  departments: DeptStats[];
}

export interface DeptDataResponse {
  overallData: DeptOverallStats | null;
  yearWiseData: YearlyDeptData[];
}

interface eventState {
  eventStats: any[];
  eventUserRegisteredCheckInStats: [];
  topTenVolunteersQuater: [];
  topTenVolunteersYear: [];
  dataBydept: DeptDataResponse;
  emailList: [];
}

const initialState: eventState = {
  eventStats: [],
  eventUserRegisteredCheckInStats: [],
  topTenVolunteersQuater: [],
  topTenVolunteersYear: [],
  dataBydept: { overallData: null, yearWiseData: [] },
  emailList: [],
};

const eventStatsSlice = createSlice({
  name: "eventStats",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(eventYearlyCombinedStats.fulfilled, (state, action) => {
        state.eventStats = action.payload;
      })
      .addCase(
        combinedEventAndRegisteredUserStatistics.fulfilled,
        (state, action) => {
          state.eventStats = action.payload;
        }
      )
      .addCase(getMonthlyEventsData.fulfilled, (state, action) => {
        state.eventUserRegisteredCheckInStats = action.payload;
      })
      .addCase(getTopTenVolunteersQuater.fulfilled, (state, action) => {
        state.topTenVolunteersQuater = action.payload;
      })
      .addCase(getTopTenVolunteersYear.fulfilled, (state, action) => {
        state.topTenVolunteersYear = action.payload;
      })
      .addCase(getEventsDataBydept.fulfilled, (state, action) => {
        state.dataBydept = {
          overallData: action.payload?.overallData ?? null,
          yearWiseData: Array.isArray(action.payload?.yearWiseData)
            ? action.payload.yearWiseData
            : [],
        };
      })
      .addCase(sendTopTenVolunteersEmail.fulfilled, (state, action) => {
        state.emailList = action.payload;
      });
  },
});

export default eventStatsSlice.reducer;

export const eventYearlyCombinedStats = createAsyncThunk(
  "events/combinedEventStatistics",
  async () => {
    const response = await axiosInstance.get(
      `api/events/combinedEventStatistics`
    );
    return response.data;
  }
);

export const combinedEventAndRegisteredUserStatistics = createAsyncThunk(
  "events/combinedEventAndRegisteredUserStatistics",
  async () => {
    const response = await axiosInstance.get(
      `api/events/admin/combinedEventAndRegisteredUserStatistics`
    );
    return response.data;
  }
);

export const getMonthlyEventsData = createAsyncThunk(
  "events/getMonthlyEventsData",
  async (data: any) => {
    const response = await axiosInstance.get(
      `api/events/admin/getEventIdDetails?month=${data.month}&year=${data.year}`
    );
    return response.data;
  }
);
export const getTopTenVolunteersQuater = createAsyncThunk(
  "events/getToptenVolunteers",
  async () => {
    const response = await axiosInstance.get(`api/events/getToptenVolunteers`);
    return response.data;
  }
);
export const getTopTenVolunteersYear = createAsyncThunk(
  "events/getToptenVolunteersForYear",
  async () => {
    const response = await axiosInstance.get(
      `api/events/getToptenVolunteersForYear`
    );
    return response.data;
  }
);
export const getEventsDataBydept = createAsyncThunk(
  "events/getAllDepartments",
  async () => {
    const response = await axiosInstance.get<DeptDataResponse>(
      `api/events/getEventsDataBydept`
    );
    return response.data;
  }
);
export const sendTopTenVolunteersEmail = createAsyncThunk(
  "events/sendTopTenVolunteersEmail",
  async (data: any) => {
    const response = await axiosInstance.post(
      `api/events/sendTopTenVolunteersEmail`,
      data
    );
    return response.data;
  }
);
